import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import reduce from 'lodash/reduce';

var UrlGenerator =
/*#__PURE__*/
function () {
  function UrlGenerator(routes, opts) {
    _classCallCheck(this, UrlGenerator);

    this.routes = routes;
    this.options = _objectSpread({
      paramFormat: '\:{key}(\\([^\\)]*\\))?'
    }, opts);
  }

  _createClass(UrlGenerator, [{
    key: "route",
    value: function route(key, opts) {
      var options = _objectSpread({
        withHost: false
      }, this.options, {}, opts);

      var withHost = options.withHost,
          paramFormat = options.paramFormat,
          params = _objectWithoutProperties(options, ["withHost", "paramFormat"]);

      var route = this.routes[key] || key;
      var url = reduce(params || {}, function (str, v, k) {
        return str.replace(new RegExp(paramFormat.replace(/\{\s*key\s*\}/gi, k), 'i'), v);
      }, route);
      var host = typeof window !== 'undefined' ? "".concat(window.location.protocol, "//").concat(window.location.host) : '';
      var hostPattern = host !== null ? "^".concat(host) : '^$';

      if (typeof withHost !== 'undefined' && withHost === true) {
        return !url.match(hostPattern) ? "".concat(host).concat(url) : url;
      }

      var urlWithoutHost = url.replace(new RegExp(hostPattern, 'i'), '');
      return urlWithoutHost === '' ? '/' : urlWithoutHost;
    }
  }]);

  return UrlGenerator;
}();

export default UrlGenerator;